import React from 'react';
import { Lock, MessageCircle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';
import { useSupportWhatsApp, fmtPhone, waLink } from '@/lib/support';

export const StockWalletLocked = () => {
    const { user } = useAuth();
    const wa = useSupportWhatsApp();
    const msg = `Hello Eagle Eyes Services, please unlock stock wallet loading for my account.\n\nName: ${user?.name || ''}\nEmail: ${user?.email || ''}\nState: ${user?.state || ''}\n\nThank you.`;
    return (
        <Card className="p-4 sm:p-5 border-amber-200 bg-amber-50/60" data-testid="user-stock-wallet-locked">
            <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-full bg-amber-100 flex items-center justify-center shrink-0"><Lock className="h-5 w-5 text-amber-700" /></div>
                <div className="min-w-0 flex-1">
                    <div className="font-display font-semibold">Stock wallet loading is locked</div>
                    <p className="text-xs text-muted-foreground mt-0.5">To add funds to your stock wallet, you first need permission. Send us a request on WhatsApp and we'll unlock it for you.</p>
                    <div className="mt-3 rounded-lg border border-amber-200 bg-white p-3">
                        <div className="text-[11px] uppercase tracking-wider text-muted-foreground">Our WhatsApp</div>
                        <div className="font-display text-lg font-semibold tabular-nums" data-testid="stock-unlock-whatsapp-number">{fmtPhone(wa)}</div>
                        <div className="mt-2 text-[11px] text-muted-foreground">Message that will be sent:</div>
                        <pre className="mt-1 whitespace-pre-wrap font-sans text-xs text-foreground/80" data-testid="stock-unlock-message">{msg}</pre>
                    </div>
                    <Button asChild className="mt-3 bg-[#25D366] hover:bg-[#1EBE5A] text-white" data-testid="stock-unlock-send-now">
                        <a href={waLink(wa, msg)} target="_blank" rel="noopener noreferrer"><MessageCircle className="h-4 w-4 mr-1.5" /> Send now</a>
                    </Button>
                </div>
            </div>
        </Card>
    );
};
